import Notice from 'components/ui/notice'

import { IExchangeData } from 'store/fetchers/loans/enum'
import { ICurrency } from 'store/fetchers/currencies'

import { ReactElement } from 'react'
import cn from 'classnames'

import { useTranslation } from 'utils/use-translation'
import TabsSlider from 'components/ui/tabs-slider'
import AprOptions from 'components/ui/apr-options'
import useWindowWidth from 'hooks/use-window-width'

import styles from './styles.module.scss'

export default function TermsBlock({
  exchange,
  ltvOptions,
  ltvPercent,
  handleChangeLvtPercent,
  handleChangeAprOption,
  aprOptions,
  activeAprOption,
  aprDiscount,
}: {
  exchange: IExchangeData
  to: ICurrency
  ltvOptions: string[]
  ltvPercent: string
  handleChangeLvtPercent: (value: string) => void
  handleChangeAprOption: (value: string) => void
  aprOptions: any[]
  activeAprOption: string
  aprDiscount?: string
}): ReactElement {
  const { t } = useTranslation()
  const width = useWindowWidth()

  return (
    <section className={styles.container}>
      <div className={styles.item}>
        <div className={styles['item-name']}>
          <p>{t('ltv')}</p>
          <Notice alt={'ltv-notice'} type="secondary" arrowOffsetX={-16} big>
            <span dangerouslySetInnerHTML={{ __html: t('loan_to_value_ratio_strong') }}></span>
          </Notice>
        </div>
        <div className={styles['item-options']}>
          {ltvOptions?.length > 0 && (
            <TabsSlider
              tabs={ltvOptions}
              activeTab={ltvPercent}
              handleTabChange={handleChangeLvtPercent}
              type="white"
              className={styles['ltv-options__wrapper']}
            />
          )}
        </div>
      </div>

      <div className={cn(styles.item, styles.column)}>
        <div className={styles['item-name']}>
          <p>{t('choose_apr')}</p>
          <Notice alt={'choose-apr-notice'} type="secondary" arrowOffsetX={-16} big>
            {aprOptions.length > 2 ? t('apr_notice_dynamic_fixed') : t('apr_notice_dynamic_fixed_2')}
          </Notice>
        </div>
        <div
          className={cn(styles['item-value__apr'], {
            [styles.clipped]: width <= 480 || (width <= 1206 && width >= 1021),
          })}
        >
          <AprOptions
            data={aprOptions}
            activeOption={activeAprOption}
            handleChangeOption={handleChangeAprOption}
            isSwipable={width <= 480 || (width <= 1206 && width >= 1021)}
            containerClassName={styles.apr__container}
            discount={aprDiscount && aprDiscount !== '0' ? aprDiscount : null}
            ltvPercent={exchange?.ltv_multiply}
          />
        </div>
      </div>
    </section>
  )
}
